<div
  class="card card-md border-0 available-account-balance
  {{ isLoading ? 'skeleton-loader' : 'loaded' }}
  {{ isEmployeeCardBalance() ? 'bg-secondary-subtle' : 'bg-secondary' }}"
  [class.text-white]="!isEmployeeCardBalance()">
  <div class="card-body align-content-center">
    <div class="row gx-4">
      <div class="col-auto">
        <div
          class="icon-rounded bg-white"
          [class.loading]="isLoading"
          [class.text-secondary]="!isEmployeeCardBalance()">
          @if (isEmployeeCardBalance()) {
          <i class="pays-svg-icon ic-card-app"></i>
          } @else {
          <i class="pays-svg-icon ic-card-2"></i>
          }
        </div>
      </div>
      <div class="col">
        <div>
          <div
            class="badge rounded-pill mb-1 {{ isEmployeeCardBalance() ? 'bg-dark': 'bg-white text-dark'}}"
            [class.loading]="isLoading">
            {{ isEmployeeCardBalance() ? 'Employee' : 'Subscription' }} cards
          </div>
        </div>
        <div>
          <div
            class="fw-medium title"
            [class.loading]="isLoading">
            Unallocated balance
          </div>
        </div>
        <div>
          <div
            class="amounts"
            [id]="isEmployeeCardBalance() ? 'employeeCardBalance' : 'subCardBalance'"
            [ngClass]="{ 'loading min-w-100': isLoading }">
            @if ( isEmployeeCardBalance() ) { {{ accountBalance()?.balance_physical | currency: 'ZAR' : 'symbol-narrow'
            | emptyIndicator }} } @else { {{ accountBalance()?.balance_virtual | currency: 'ZAR' : 'symbol-narrow' |
            emptyIndicator }} }
          </div>
        </div>
      </div>
      <div
        class="col"
        [class.border-start]="!isLoading">
        <div class="row flex-nowrap align-items-end">
          <div class="col-auto">
            <div class="app-card-balance-graph-wrapper">
              @if (isLoading) {
              <div class="circle-chart-78"></div>
              } @else {
              <div
                [id]="isEmployeeCardBalance() ? 'employeeCardBalancePercentage' : 'subscriptionCardBalancePercentage'"
                class="invisible">
                {{ isEmployeeCardBalance() ? allocationPercentagePhysical() : allocationPercentageVirtual() }}
              </div>
              <app-circle-graph
                baseColour="#F9F9FB"
                dataColour="#337CA6"
                [radius]="33"
                [strokeWidth]="10"
                [data]="isEmployeeCardBalance() ? allocationPercentagePhysical() : allocationPercentageVirtual()"></app-circle-graph>
              }
            </div>
          </div>
          <div class="col">
            @if (!isLoading) {
            <div class="legend-chip on-cards"></div>
            }
            <div
              class="fw-medium d-block fs-5"
              [ngClass]="{ 'loading d-block': isLoading }">
              @if (isEmployeeCardBalance()) { {{ accountBalance()?.balance_physical_cards | currency: 'ZAR' :
              'symbol-narrow' | emptyIndicator }} } @else { {{ accountBalance()?.balance_virtual_cards | currency: 'ZAR'
              : 'symbol-narrow' | emptyIndicator }} }
            </div>
            <div
              [class.loading]="isLoading"
              [class.text-gray-500]="isEmployeeCardBalance()">
              On cards
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
